import React from "react";
import {
  View,
  Text,
  Modal,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

const statusDetails = [
  {
    status: "Scheduled to Ship",
    description: "Waiting for the paperwork to be finalised",
    icon: "clock-o",
    color: "#f0ad4e",
  },
  {
    status: "Arrived",
    description: "Arrived at the destination port",
    icon: "ship",
    color: "#5bc0de",
  },
  {
    status: "Shipped",
    description: "Left China Port",
    icon: "plane",
    color: "#0275d8",
  },
  {
    status: "Closed",
    description: "Order is completed",
    icon: "check-circle",
    color: "#5cb85c",
  },
  {
    status: "Partially Shipped",
    description: "Some items have been shipped, others are still pending",
    icon: "exchange",
    color: "#f7a35c",
  },
  {
    status: "New Order",
    description: "Order has been recently placed",
    icon: "plus-circle",
    color: "#31b0d5",
  },
  {
    status: "Rushed Order",
    description: "Order is being expedited",
    icon: "bolt",
    color: "#d9534f",
  },
  {
    status: "Order Placed",
    description: "Order has been submitted to the supplier",
    icon: "shopping-cart",
    color: "#999",
  },
  {
    status: "On Hold",
    description: "Order is temporarily paused",
    icon: "pause-circle",
    color: "#777",
  },
];

const OrderStatusHelp = ({ visible, onClose }: any) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <TouchableOpacity style={styles.modalOverlay} activeOpacity={1}>
        <View style={styles.modalContent}>
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Icon name="times" size={18} color="#555" />
          </TouchableOpacity>

          <Text style={styles.modalTitle}>Order Status Definitions</Text>

          <ScrollView style={styles.scrollContainer}>
            {statusDetails.map((item, index) => (
              <View key={index} style={styles.statusItem}>
                <View style={styles.statusHeader}>
                  <Icon
                    name={item.icon}
                    size={16}
                    color={"#000"}
                    style={{ marginRight: 8 }}
                  />
                  <Text style={[styles.statusText, { color: "#000" }]}>
                    {item.status}
                  </Text>
                </View>
                <Text style={styles.descriptionText}>{item.description}</Text>
              </View>
            ))}
          </ScrollView>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContent: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 20,
    width: "85%",
    maxHeight: "85%",
    position: "relative",
    elevation: 10,
  },
  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 1,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: "700",
    marginBottom: 16,
    textAlign: "center",
    color: "#333",
  },
  scrollContainer: {
    maxHeight: 400,
  },
  statusItem: {
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
  },
  statusHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  statusText: {
    fontWeight: "bold",
    fontSize: 14,
  },
  descriptionText: {
    fontSize: 12,
    color: "#666",
    marginLeft: 24,
  },
});

export default OrderStatusHelp;
